import styled from 'styled-components';

export {
  Image,
  ImagePlaceholder,
  ImageWrapper,
  Name,
  Reward,
} from '../home/card_subscription/main/rewards/item.styles';

export const RewardAndButtonWrapper = styled.div`
  width: 112px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;
